import {createTheme} from "@mui/material";

export const theme = createTheme({
    typography: {
        fontFamily: [
            'Noto Sans JP, sans-serif',
            'Roboto',
            'Questrial, sans-serif',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    palette: {
        primary: {
            main: "#210062",
            // main: "#335eea",
            // main: "#7f2bef",
            // main: "#5030ff",
        },
        secondary: {
            main: "#FF009D",
        },
        background: {
            default: "#fdfdfd"
        }
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                color: 'white',
            },
        },
    }
});
